import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import KonkurrenceOpgavePresenter from './KonkurrenceOpgavePresenter';
import { Spinner } from '../../uiComponents/Spinner';
import IApiCaller from '../../infrastructure/api/IApiCaller';
import { OpgavepakkeOpgaveListItem } from '../../models/OpgavepakkeOpgaveListItem';
import { SelectFormControl } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { Konkurrence } from '../../models/Konkurrence';
import { DetailedOpgavepakkeOpgaveEkstern } from '../../models/DetailedOpgavepakkeOpgaveEkstern';
import { PrintButton } from '../../uiComponents/input/Buttons';
import TabContent from '../../uiComponents/layout/TabContent';
import KonkurrenceOpgaveOftestStilledeSpoergsmaal from './KonkurrenceOpgaveOftestStilledeSpoergsmaal';
import Tabs from '../../uiComponents/layout/Tabs';

export interface KonkurrenceOpgaveEksternContainerProps extends RouteComponentProps<any> { }

interface KonkurrenceOpgaveEksternContainerState {
    selectedOpgavepakkeopgave?: DetailedOpgavepakkeOpgaveEkstern;
    opgavepakkeOpgaver?: OpgavepakkeOpgaveListItem[];
    konkurrence?: Konkurrence;
    selectedTabName: string;
}

class KonkurrenceOpgaveEksternContainer extends React.Component<KonkurrenceOpgaveEksternContainerProps,
    KonkurrenceOpgaveEksternContainerState> {

    private _pageTabs: Map<number, string>;
    private _tabContent: any[];

    constructor(props: KonkurrenceOpgaveEksternContainerProps) {
        super(props);

        this.state = {
            opgavepakkeOpgaver: undefined,
            selectedOpgavepakkeopgave: undefined,
            selectedTabName: this.props.match.params.tab
        };

        this.setStateFromResponse = this
            .setStateFromResponse
            .bind(this);

        this.onTabChanged = this.onTabChanged.bind(this);
    }

    public get tabContent(): any[] {
        return this._tabContent;
    }
    public set tabContent(v: any[]) {
        this._tabContent = v;
    }

    public get pageTabs(): Map<number, string> {
        return this._pageTabs;
    }
    public set pageTabs(v: Map<number, string>) {
        this._pageTabs = v;
    }

    componentDidMount() {
        let self = this;
        let konkurrenceId = this.props.match.params.konkurrenceId;
        let opgavePakkeOpgaveId = this.props.match.params.opgavePakkeOpgaveId;
        let apiCaller = createApiCaller();

        if (konkurrenceId !== undefined && konkurrenceId.length > 0 && opgavePakkeOpgaveId !== undefined && opgavePakkeOpgaveId.length > 0) {
            apiCaller.getKonkurrence(konkurrenceId).then(data => this.setState({
                konkurrence: data
            }));

            if (opgavePakkeOpgaveId !== undefined && opgavePakkeOpgaveId.length > 0) {
                self.getContentFromApi(apiCaller, konkurrenceId, opgavePakkeOpgaveId)
                    .then(response => {
                        this.setStateFromResponse(response);
                    });
            }
        }
    }

    onTabChanged(changedKey: number) {
        let tabName = 'opgave';
        switch (changedKey) {
            case 0:
                tabName = 'opgave';
                break;
            case 2:
                tabName = 'ofteststilledespoergsmaal';
                break;
            default:
                break;
        }

        this.setState({ selectedTabName: tabName });

        this.pushTabHistory(tabName);
    }

    pushTabHistory(tabName: string) {
        const url = this.getRedirectUrl(this.props.match.params.opgavePakkeOpgaveId) + '/' + tabName;
        this.props.history.push(url);
    }

    constructTabs() {
        let tabs = new Map<number,
            string>();
        let tabContents = new Array();

        if (this.state.selectedOpgavepakkeopgave !== undefined) {
            tabs.set(0, 'Opgave');

            let konkurrenceDag = this.state.konkurrence !== undefined && this.state.konkurrence !== null ? this.state.konkurrence.startdato : undefined;
            let konkurrenceStatus = this.state.konkurrence !== undefined && this.state.konkurrence !== null ? this.state.konkurrence.status : undefined;

            tabContents.push((
                <TabContent tabName='0' defaultActive={this.state.selectedTabName === 'opgave'}>
                    <PrintButton text='Udskriv' />
                    <KonkurrenceOpgavePresenter
                        opgave={this.state.selectedOpgavepakkeopgave.opgave}
                        konkurrenceId={this.props.match.params.konkurrenceId}
                        konkurrenceDag={konkurrenceDag}
                        konkurrenceStatus={konkurrenceStatus}
                    />
                </TabContent>
            ));

            if (this.state.selectedOpgavepakkeopgave.opgave.oftestStilledeSpoergsmaalIndhold !== undefined && this.state.selectedOpgavepakkeopgave.opgave.oftestStilledeSpoergsmaalIndhold !== null) {
                tabs.set(2, 'Oftest stillede spørgsmål');
                tabContents.push((
                    <TabContent tabName='2' defaultActive={this.state.selectedTabName === 'ofteststilledespoergsmaal'}>
                        <KonkurrenceOpgaveOftestStilledeSpoergsmaal opgave={this.state.selectedOpgavepakkeopgave.opgave} />
                    </TabContent>
                ));
            }
        }

        this.pageTabs = tabs;
        this.tabContent = tabContents;
    }

    getContentFromApi = (apiCaller: IApiCaller, konkurrenceId: string, opgavepakkeOpgaveId: string) => {
        return apiCaller
            .getDetailedOpgaveEkstern(konkurrenceId, opgavepakkeOpgaveId);
    }

    setStateFromResponse(konkurrenceOpgave: DetailedOpgavepakkeOpgaveEkstern) {
        this.setState({ opgavepakkeOpgaver: konkurrenceOpgave.opgavepakkeOpgaver, selectedOpgavepakkeopgave: konkurrenceOpgave });
    }

    getPageTitle() {
        return this.state.selectedOpgavepakkeopgave !== undefined
            ? this.state.selectedOpgavepakkeopgave.opgave.titel
            : '';
    }

    getRedirectUrl(opgavepakkeOpgaveId: string): string {
        var konkurrenceId = this.props.match.params.konkurrenceId;
        return '/konkurrence/' + konkurrenceId + '/opgavepakkeopgave/' + opgavepakkeOpgaveId + '/opgave';
    }

    onOpgavepakkeOpgaveSelectChange = (e: any) => {
        let apiCaller = createApiCaller();
        let opgavepakkeOpgaveId = e.target.value;
        this.setState({ selectedOpgavepakkeopgave: undefined });
        this.getContentFromApi(apiCaller, this.props.match.params.konkurrenceId, opgavepakkeOpgaveId)
            .then(response => {
                this.setStateFromResponse(response);
                const url = this.getRedirectUrl(opgavepakkeOpgaveId);
                this.props.history.push(url);
            });
    }

    getOpgavepakkeOpgaveSelect = () => {
        if (this.state.selectedOpgavepakkeopgave !== undefined && this.state.opgavepakkeOpgaver !== undefined && this.state.opgavepakkeOpgaver.length > 0) {
            const opgaveList = this.state.opgavepakkeOpgaver
                .map((o) => {
                    return <option key={o.id} value={o.id}>{o.name} ({o.opgavepakkenavn})</option>;
                });
            return (
                <SelectFormControl value={this.state.selectedOpgavepakkeopgave.opgavepakkeOpgaveId} onChange={this.onOpgavepakkeOpgaveSelectChange} className='opgavepakkeopgave-select'>
                    {opgaveList}
                </SelectFormControl>
            );
        }

        return undefined;
    }

    getTabContents() {
        return this.tabContent;
    }

    getActiveTabIndex(): number {
        var tab = this.state.selectedTabName;
        switch (tab) {
            case 'opgave':
                return 0;
            case 'ofteststilledespoergsmaal':
                return 2;
            default:
                return 0;
        }
    }

    render() {
        this.constructTabs();

        if (this.state.selectedOpgavepakkeopgave === undefined || this.state.konkurrence === undefined) {
            return <Spinner />;
        } else {
            return (
                <PageWrapper className='opgave-visning ekstern-opgave-visning'>
                    <PageTitle title={this.getPageTitle()}>
                        {this.getOpgavepakkeOpgaveSelect()}
                    </PageTitle>
                    <Tabs columns={this.pageTabs} defaultColumnKey={this.getActiveTabIndex()} onTabChanged={this.onTabChanged}>
                        {this.getTabContents()}
                    </Tabs>
                    
                </PageWrapper>
            );
        }
    }
}

export default KonkurrenceOpgaveEksternContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceOpgaveEksternContainer.tsx